import React, { FC } from 'react';
import styles from './PaymnetExtractResume.module.scss';
import { IExtract } from '../../../../../modules/consume/domain/models/Extract';
import { moneyMaskNumber } from '../../../../../services/utils/Money';
import { useI18n } from '../../../../../hooks/useI18n';

interface IPaymnetExtractResumeProps {
    extract: IExtract; payServiceFee: boolean; totalToPay: number; partialAmount: number; discount?: number; appliedDiscount?: number;
}
export const PaymnetExtractResume: FC<IPaymnetExtractResumeProps> = ({ extract, payServiceFee, totalToPay, partialAmount, appliedDiscount, discount }) => {
    const { t } = useI18n();

    return <div className={styles.extractResume}>
        <b>{t('paymentSummary.accountResume')}</b>
        <div className={styles.total}>
            <label>{t('paymentSummary.subtotal')}</label><span>{moneyMaskNumber(extract.totalAmount)}</span>
        </div>
        {/* {!!extract.serviceFeeConfig.serviceFeePercentage && */}
        {!!extract.serviceFeeConfig &&
            <div className={styles.total} style={{ textDecoration: payServiceFee ? "" : "solid line-through var(--secondary-color) 2px" }}>
                <label>{t('paymentSummary.serviceFee')} ({extract.serviceFeeConfig?.serviceFeePercentage * 100}%)</label><span> + {moneyMaskNumber(extract.serviceFeeConfig.serviceFeeAmount)}</span>
            </div>}
        <div className={styles.total}>
            <label>{t('paymentSummary.totalConsumed')}</label><span>{moneyMaskNumber(extract.totalAmount)}</span>
        </div>
        <div className={styles.total}>
            <label>{t('paymentSummary.totalPaid')}</label><span>{moneyMaskNumber(extract.paidAmount)}</span>
        </div>
        {discount && <div className={styles.total}>
            <label>{t('paymentSummary.discount')}</label><span>{moneyMaskNumber(-discount)}</span>
        </div>}
        <div className={styles.total}>
            <label>{t('paymentSummary.totalRemaining')}</label><span>{moneyMaskNumber(totalToPay - (discount ?? 0))}</span>
        </div>
        {!!appliedDiscount && <div className={styles.total}>
            <label>{t('paymentSummary.discountAlreadyApplied')}</label><span>{moneyMaskNumber(-appliedDiscount)}</span>
        </div>}
        <div className={styles.partial}>
            <div className={styles.value}>
                <label>{t('paymentSummary.amountToPay')}</label><span>{moneyMaskNumber(partialAmount)}</span>
            </div>
            {partialAmount !== totalToPay &&
                <div className={styles.remain}>
                    <label>{t('paymentSummary.remainingAmount')}</label><span>{moneyMaskNumber((payServiceFee ? extract.totalToPayWithFee : extract.totalToPayWithoutFee) - partialAmount - (discount ?? 0))}</span>
                </div>
            }
        </div>
    </div>;
};
